import React, {Component} from 'react';
import {gpn} from "../GPN"
import axios from "axios";
import config from "../config";
import Field from "../sections/MUI/Field";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";

class Init extends Component {

    state = {
        firstName: "",
        lastName: "",
        phoneNumber: ""
    };

    componentDidMount() {
        if (config.token !== "") {
            document.location.href = "/";
        } else {
            this.checkInit();
        }
    }

    checkInit() {
        axios.get(`${config.api}/admin/init/check`)
            .then(r => {
                if (r.data.status) {
                    document.location.href = "/login"
                }
            })
            .catch(err => {
            });
    }

    handleInit() {
        const {firstName, lastName, phoneNumber} = this.state;

        if (firstName !== "" && lastName !== "" && phoneNumber !== "") {
            let params = new URLSearchParams();
            params.append("firstName", firstName);
            params.append("lastName", lastName);
            params.append("phoneNumber", phoneNumber);

            axios.post(`${config.api}/admin/init`, params)
                .then(r => {
                    toast.success("با موفقیت ثبت شد. وارد شوید.");

                    setTimeout(() => {
                        document.location.href = "/login";
                    }, 1500)
                })
                .catch(err => {
                    toast.error("خطایی رخ داده است!")
                });
        } else {
            toast.error("همه فیلد ها را تکمیل کنید")
        }
    }

    render() {
        const {firstName, lastName, phoneNumber} = this.state;
        return (
            <div className="init-admin">
                <div className="card">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <Field name="firstName"
                                   value={firstName}
                                   label="نام"
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                        </div>
                        <div className="col-md-6">
                            <Field name="lastName"
                                   value={lastName}
                                   label="نام خانوادگی"
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                        </div>
                        <div className="col-md-6">
                            <Field name="phoneNumber"
                                   value={phoneNumber}
                                   maxLength={13}
                                   label="شماره موبایل"
                                   onChange={(name, value) => this.setState({[name]: value})}/>

                        </div>
                        <div className="col-md-7">
                            <Button submit={false}
                                    icon="check"
                                    onClick={() => this.handleInit()}>ثبت ادمین</Button>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default gpn(Init);